$(".age-gate-form select").attr("name", "country");

var sessionValidation = $(".age-gate").data("session");
if (sessionValidation !== undefined && sessionValidation.result !== undefined) {
    updateForm(sessionValidation);
}

/**
 * Check Age Gate form form
 * @param {*} countryCode
 */
function checkAgeGateForm(countryCode) {
    var yearInput = $(".yearField");
    var monthInput = $(".monthField");
    var dayInput = $(".dayField");
    var year = parseInt(yearInput.val(), 10);
    var countryLegalAge = parseInt($("#country :selected").data("year"), 10);
    if (countryCode === "US" || (countryLegalAge > 0 && countryLegalAge === year)) {
        dayInput.removeClass("d-none").prop("disabled", false);
        $(".dayInputWrapper").removeClass("d-none");
        monthInput.removeClass("d-none").prop("disabled", false);
        $(".monthInputWrapper").removeClass("d-none");
        yearInput.css("width", "35%");
    } else {
        dayInput.addClass("d-none").prop("disabled", true);
        $(".dayInputWrapper").addClass("d-none");
        monthInput.addClass("d-none").prop("disabled", true);
        $(".monthInputWrapper").addClass("d-none");
        yearInput.css("width", "100%");
    }
    checkButton(countryCode, yearInput.val(), monthInput.val(), dayInput.val());
}

/**
 * Used to disable or enable a submit button
 * @param {*} countryCode
 * @param {*} year
 * @param {*} month
 * @param {*} day
 */
function checkButton(countryCode, year, month, day) {
    var d = new Date();
    $(".page-age-gate button").prop("disabled", false);
    var lengthYear;
    if (year) {
        lengthYear = year.length;
    }
    var validYear = lengthYear !== 4 || year < 1900 || year > d.getFullYear();
    $(".age-gate input:enabled:not(#rememberMe)").each(function (_index, value) {
        if (
            (countryCode === "US" &&
                (!$(value).val() || validYear || month > 12 || month < 1 || day > 31 || day < 1)) ||
            !$(value).val() ||
            validYear
        ) {
            $(".page-age-gate button").prop("disabled", "true");
        }
    });
}

/**
* Hides the age gate modal
*/
function hideAgeGate() {
    var $ageGate = $(".page-age-gate");
    $ageGate.addClass("d-none");
    $("body").removeClass("overflow-hidden");

    if ($(".polaroid-animation-wrapper").length) {
        $("html").animate({
            scrollTop: 0
        }, 300, function () {
            $ageGate.addClass("initialized");
        });
    } else {
        $(window).scrollTop(0);
    }
}

/**
 * Update Form if submission was successful and handle page redirection via redirectBehavior object
 * @param {Object} data
 * @param {Object} redirectBehavior
 */
function updateForm(data, redirectBehavior) {
    if (data.result) {
        if (redirectBehavior) {
            if (redirectBehavior.redirectLocale) {
                $.ajax({
                    url: redirectBehavior.redirectLocale,
                    data: JSON.stringify({
                        currentPage: $("#currentPagePath").val(),
                        currentParams: $("#currentPageParams").val()
                    }),
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    success: function (redirectData) {
                        if (redirectData && redirectData.redirectUrl) {
                            window.location.href = redirectData.redirectUrl;
                        } else {
                            hideAgeGate();
                        }
                    },
                    error: function () {
                        hideAgeGate();
                    }
                });
            } else if (redirectBehavior.redirectURL) {
                window.location.href = redirectBehavior.redirectURL;
            } else {
                hideAgeGate();
            }
        } else {
            hideAgeGate();
        }
    } else {
        $(".age-gate-content").addClass("d-none");
        $(".age-gate-forbidden").removeClass("d-none");
        if (data.url) {
            setTimeout(function () {
                window.location.href = data.url;
            }, 10000);
        }
    }
}

$(document).on("input", function () {
    checkAgeGateForm($("#country").val());
});

$(document).on("input", ".age-gate-form input", function () {
    this.value = this.value.replace(/\D/g, "");
});

$("input").on("input", function () {
    if ($(this).val().length === parseInt($(this).attr("maxlength"), 10)) {
        // Find the closest parent that contains the current input
        var parentDiv = $(this).closest("div");

        // Find the next input element within the same parent or in the next sibling div
        var nextInput = parentDiv.nextAll("div").find("input").first();

        if (nextInput.length) {
            nextInput.focus();
        }
    }
});

$(".age-gate-submit").on("click", function (e) {
    var selectedInput = $("option:selected", this.form);
    var redirectBehavior = {
        redirectLocale: selectedInput.data("redirectlocale"),
        redirectURL: selectedInput.data("redirecturl")
    };

    e.preventDefault();
    $.ajax({
        type: "POST",
        url: $(".age-gate-form").attr("action"),
        data: $(".age-gate-form").serialize(),
        success: function (data) {
            updateForm(data, redirectBehavior);
        },
    }).done(function() {
        $.ajax({
            type: "GET",
            url: $(".eretailers_details").attr("data-render-retailers"),
            success: function (data) {
                if (data) {
                    $(".eretailers_details").replaceWith(data);
                }
            },
        });
    });
});

let $rememberMe = $("#rememberMe");

if ($rememberMe.length) {
    $rememberMe.on("click", function () {
        let $this = $(this);

        $this.attr("value", $this.prop("checked") ? "1" : "0");
    });
}

// Add overflow hidden for body when the age gate modal is shown
if ($(".page-age-gate")[0] && !$(".page-age-gate").hasClass("d-none")) {
    $("body").addClass("overflow-hidden");
}
